import { render, staticRenderFns } from "./Comprehensive.vue?vue&type=template&id=dc1f1514"
import script from "./Comprehensive.vue?vue&type=script&lang=js"
export * from "./Comprehensive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports